// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanUpdateWorkspace } from "./hook";

export type CanUpdateWorkspaceProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanUpdateWorkspace({
  children,
  fallback,
  scope,
}: CanUpdateWorkspaceProps) {
  const canDoAction = useCanUpdateWorkspace(scope);
  return <>{canDoAction ? children : fallback}</>;
}
